
import Component from "vue-class-component";
import Vue from "vue";
import { SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { formatDateWithTime } from "@/utils";
import notifications from "../../lib/notifications";
import {
  GetCommodityUnloadTimesRequest,
  CommodityUnloadTimeResource,
  EditCommodityUnloadTimeModel
} from "../../models/api/system/commodityUnloadTime";
import moment from "moment";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ImportTrucks extends Vue {
  commodities: any = null;
  commodityCode: string = null;
  loading: boolean = false;
  records: CommodityUnloadTimeResource[] = null;
  editId: number = null;
  editModel: EditCommodityUnloadTimeModel = null;

  timeInformation: any = {
    hours: "00",
    minutes: "00",
    seconds: "00",
    modalIsVisible: false
  };

  async created() {
    await this.loadCommodities();
    await this.loadData();
  }
  async loadCommodities() {
    try {
      const results = await systemModule.searchCommoditiesByCode({ code: null, billTo: null });
      this.$data.commodities = results.map(x => ({ label: x.code, value: x.code }));
    } catch (ex) {
      console.error("Failed to load commodities", ex);
    }
  }

  async loadData() {
    this.loading = true;
    try {
      this.records = await systemModule.getCommodityUnloadTimes({
        commodityCode: this.commodityCode
      });
    } catch (ex) {
      notifications.error("Search Failed", "Failed to load records", ex);
    }
    this.loading = false;
  }

  format(dateToFormat) {
    return formatDateWithTime(dateToFormat);
  }

  goBack() {
    this.$router.back();
  }

  async filter() {
    await this.loadData();
  }

  editRecord(record: CommodityUnloadTimeResource = null) {
    const model = new EditCommodityUnloadTimeModel();
    if (record) {
      const data = record.timePerUnit.split(":");

      model.commodityCode = record.commodityCode;
      this.timeInformation.hours = data[0];
      this.timeInformation.minutes = data[1];
      this.timeInformation.seconds = data[2];
    } else {
      this.timeInformation.hours = "00";
      this.timeInformation.minutes = "00";
      this.timeInformation.seconds = "00";
    }

    this.editModel = model;
  }

  closeEditModal() {
    this.editModel.visible = false;
    this.editModel = null;
  }

  async saveRecord() {
    try {
      this.editModel.saving = true;
      this.editModel.timePerUnit =
        this.timeInformation.hours +
        ":" +
        this.timeInformation.minutes +
        ":" +
        this.timeInformation.seconds;
      await systemModule.createCommodityUnloadTimes(this.editModel.toCreateRequest());
      await this.loadData();
      this.editModel.visible = false;
      this.editModel = null;
      notifications.success("Save Success", "Record successfully saved");
    } catch (ex) {
      this.editModel.saving = false;
      notifications.error("Save Failed", "Failed to save record", ex);
    }
  }

  async deleteRecord(record: CommodityUnloadTimeResource) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to delete this record? This action cannot be undone."
    );
    if (confirmed) {
      try {
        await systemModule.deleteCommodityUnloadTimes(record.commodityCode);
        await this.loadData();
        notifications.success("Delete commodity unload time", "Record successfully deleted.");
      } catch (ex) {
        notifications.error("Delete commodity unload time", "Failed to delete record", ex);
      }
    }
  }

  get canFilter() {
    return true;
  }
}
